package br.com.texeratx.boardgametimeapp.core.spotify.auth

object SpotifyScopes {
    const val USER_MODIFY_PLAYBACK_STATE = "user-modify-playback-state"
    const val USER_READ_PLAYBACK_STATE = "user-read-playback-state"

    val REQUIRED: Set<String> = setOf(
        USER_MODIFY_PLAYBACK_STATE,
        USER_READ_PLAYBACK_STATE
    )
}
